import axios from 'axios'
export default {
	data: () => ({
		//code: 'Report',
		//title: '<Заголовок>',
		//subtitle: '<Підзаголовок>',
		loading: false,

		menu: {
			datebegin: false,
			dateend: false,
		},

		excel: {
			name: '',
			type: 'xlsx',
			disabled: true,
			data: []
		},

		snackbar: {
			visible: false,
			text: null,
			color: null
		},

		rules: {
			required: (value) => !!value || "Обов'язкове для заповнення",
			onlyFromList: (v) => (!!v && v?.id > 0 ) || "Необхідно обрати значення зі списку",
		},

		crumbs: [
			{ text: 'Звіти', disabled: false, to: '../Report' },
		],
	}),

	props: {
		code: 				{ type: String, default: 'Report' },
		name: 				{ type: String, default: 'Запити' },
		description: 		{ type: String, default: '' },
		run: 				{ type: Boolean, default: false },
	},

	computed: {
		module() {
			return `Report${this.code}`
		},

		params() {
			return this.$store.getters[`${this.module}/params`]
		},

		data() {
			return this.$store.getters[`${this.module}/data`]
		},

		title() {
			return this.name
		},

		subtitle() {
			return this.description
		},

		parameters() {
			return [
				{ code: 'datebegin', name: 'Дата початку періоду', description: '', type: 'date', value: this.params.datebegin },
				{ code: 'dateend', name: 'Дата завершення періоду', description: '', type: 'date', value: this.params.dateend },
			]
		},

		excelName() {
			return `${this.title}.${this.excelType}`
		},
	},

	created() {
		//console.log(this.$options.name, 'created')

		this.loadPdfComponent();
		
		let datebegin 	= new Date();
		let dateend 	= new Date(); 
		
		datebegin.setMonth(datebegin.getMonth() - 1);

		this.params.datebegin = this.datebegin ? this.datebegin : new Date(datebegin).toISOString().substr(0, 10)
		this.params.dateend = this.dateend ? this.dateend : new Date(dateend).toISOString().substr(0, 10)
	},

	mounted() {
		if(this.run) {
			this.onOK()
		}
	},

	methods: {
		loadPdfComponent() {
			const requireComponent = require.context("@/views/report/pdf", false, /[A-Z]\w+\.(vue|js)$/);
			requireComponent.keys().forEach(fileName => {
				const componentConfig = requireComponent(fileName);
				const componentName = `${fileName.split("/").pop().split(".")[0]}`;
				if(componentName == this.code) {
					this.$options.components['zPdf'] = componentConfig.default;
				}
			});
		},

		setData(data) {
			this.$store.commit(`${this.module}/data`, data);
		},

		onClear() {
			this.$refs.form.reset()
		},

		clearData() {
			this.setData({
				datasets: {
					ds: []
				}
			})
		},

		urlParams() {
			return this.params
		},

		onOK() {
			var that = this

			this.clearData()

			if (this.$refs.form.validate()) {
				//console.log(this.$options.name, 'onOK', 'VALID')
				//console.log(this.$options.name, 'params', this.urlParams())

				this.loading = true
				axios.get(`/report/${this.code}`, { params: this.urlParams() }).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					that.setData(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
				});
			}
		},

		onPDF () {
			this.$refs.pdf.generate()
		},
	},
}